import script from "./HeaderComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./HeaderComponent.vue?vue&type=script&lang=ts&setup=true"

import "./HeaderComponent.vue?vue&type=style&index=0&id=08bdc322&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08bdc322"]])

export default __exports__